import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";

export const ShipinhaoSendMsgParamsSchema = ActionCommonParamsSchema.extend({
    toUsername: z.string().min(1, "接收者用户名不能为空"), // 接收者用户名
    sessionId: z.string().min(1, "会话ID不能为空"), // 会话ID
    msgType: z.enum(["TEXT", "IMAGE"], {
        message: "消息类型必须是 TEXT 或 IMAGE",
    }), // 消息类型：TEXT-文本消息，IMAGE-图片消息
    content: z.string().optional(), // 文本消息内容（msgType=TEXT时必填）
    imageInfo: z
        .object({
            pathOrUrl: z.string().min(1, "图片路径或URL不能为空"), // 图片路径或URL
        })
        .optional(), // 图片信息（msgType=IMAGE时必填）
});
